import { useEffect, useState } from "react";
import { LuLoaderCircle, LuRefreshCw, LuX } from "react-icons/lu";
import {
  useIsProcessingRollbackError,
  useRollbackErrorHandlerActions,
} from "../../../view_stores/useRollbackErrorHandlerStore";

export default function ProjectRollbackErrorActions() {
  return (
    <div
      className="h-full w-full overflow-hidden
    flex flex-col items-center justify-start"
    >
      Something went wrong while processing your rollout request. Would you like
      to try again, or abort and use a different checkpoint?
      <Actions />
    </div>
  );
}

function Actions() {
  const isProcessingRollbackError = useIsProcessingRollbackError();

  const [selectedActionIndex, setSelectedActionIndex] = useState<number | null>(
    null
  );
  const { abort, retry } = useRollbackErrorHandlerActions();

  const handleAbort = () => {
    setSelectedActionIndex(0);
    abort();
  };

  const handleRetry = () => {
    setSelectedActionIndex(1);
    retry();
  };

  useEffect(() => {
    if (!isProcessingRollbackError && selectedActionIndex) {
      setSelectedActionIndex(null);
    }
  }, [isProcessingRollbackError, selectedActionIndex]);

  return (
    <div className="w-full flex gap-4 max-w-[500px] pt-5">
      <ActionBtn
        id="project-rollback-error-abort"
        label="Abort"
        icon={<LuX />}
        isDisabled={selectedActionIndex !== null}
        isLoading={selectedActionIndex === 0}
        bgColor="bg-white dark:bg-[#272829]"
        onClick={handleAbort}
      />

      <ActionBtn
        id="project-rollback-error-retry"
        label="Retry"
        icon={<LuRefreshCw />}
        isDisabled={selectedActionIndex !== null}
        isLoading={selectedActionIndex === 1}
        bgColor="bg-[#16A34A] text-white"
        onClick={handleRetry}
      />
    </div>
  );
}

function ActionBtn({
  id,
  label,
  icon,
  isDisabled,
  isLoading,
  bgColor,
  onClick,
}: {
  id: string;
  label: string;
  icon: React.ReactNode;
  isDisabled: boolean;
  isLoading: boolean;
  bgColor: string;
  onClick: () => void;
}) {
  return (
    <div
      className="w-full rounded-[4px] 
    relative overflow-hidden"
    >
      <button
        id={id}
        onClick={onClick}
        className={`w-full flex items-center justify-center 
    gap-2 py-2
    hover:brightness-125 hover:cursor-pointer
    transition-all duration-300 ${bgColor}`}
        disabled={isDisabled}
      >
        {icon}
        {label}
      </button>
      {isLoading && (
        <div
          className="absolute top-0 bg-black/50 w-full h-full
          flex items-center justify-center"
        >
          <LuLoaderCircle className="animate-spin text-white" size={24} />
        </div>
      )}
    </div>
  );
}
